import Disclaimer from "../../../../contents/docs/self-host/_snippets/disclaimer.mdx";
import * as React from 'react';
export default {
  Disclaimer,
  React
};